import { Constants } from "@constants";

import axios from "axios";
import { getAuthorizationToken } from "@utils/helper";

const apiService = axios.create({
  baseURL: `${Constants.API.API_PATH}`,
  withCredentials: true,
});

const requestHandler = (request) => {
  const token = getAuthorizationToken(Constants.GENIE_ACCESS_CODE);
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  request.headers["Cache-Control"] = "no-cache";
  return request;
};

const responseHandler = (response) => {
  return response;
};

const errorHandler = (error) => {
  requestInterceptorsHandler(error);
  return Promise.reject(error);
};

apiService.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => errorHandler(error)
);

apiService.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => errorHandler(error)
);

const requestInterceptorsHandler = (res) => {
  const origin = window.location.origin;
  const { response = {} } = res;
  if (response?.status === 401 || response?.systemMessage?.statue === 401) {
    let HOST = response?.data?.data?.host || "";
    if (origin.indexOf("developer.gartner.com") !== -1) {
      HOST = `${Constants.ROUTES.GENIE_AUTH_URL}?TARGET=`;
    }

    HOST = HOST + encodeURIComponent(window.location.href);
    if (window.location.pathname.includes("cybersecurity-insights")) {
      HOST = `${HOST}&name=cybersecurity-insights&version=1`;
    }
    window.location.replace(HOST);
  }
};

export default apiService;
